import * as Sentry from '@sentry/react';
import {
  Modal,
  ModalActions,
  ModalContent,
  Prose,
  Pushbutton
} from '@stratumn/atomic';
import to from 'await-to-js';
import graphql from 'babel-plugin-relay/macro';
import { removeTeamMember } from 'mutations';
import PropType from 'prop-types';
import { useState } from 'react';
import { createFragmentContainer } from 'react-relay';
import { SpanType, withSpanAsync } from 'tracing';
import { withGqlClient } from 'wrappers';

export const RemoveTeamCollaboratorModal = props => {
  const [submitted, setSubmit] = useState(false);

  const { environment, collaborator, onClose } = props;
  const {
    teams: {
      nodes: [team]
    }
  } = collaborator;

  const removeCollaboratorGp = () =>
    withSpanAsync('removeTeamMember', SpanType.processing, async () => {
      setSubmit(true);

      const [err] = await to(
        removeTeamMember(
          environment,
          collaborator.id,
          collaborator.rowId,
          team.id,
          team.rowId,
          team.organization.rowId
        )
      );

      if (err) {
        Sentry.captureException(err);
        setSubmit(false);
      } else {
        onClose();
      }

      return {};
    });

  return (
    <Modal
      closeButtonLabel="Cancel"
      handleCollapse={onClose}
      title="Remove from Team"
    >
      <ModalContent>
        <Prose
          light
          text={`This action will remove **${collaborator.name}** from the **${
            team.name
          }**`}
        />
      </ModalContent>
      <ModalActions>
        <Pushbutton data-testid="cancel-button" onClick={onClose}>
          cancel
        </Pushbutton>
        <Pushbutton
          data-testid="remove-team-collaborator-button"
          disabled={submitted}
          onClick={removeCollaboratorGp}
          warning
        >
          Remove from team
        </Pushbutton>
      </ModalActions>
    </Modal>
  );
};

RemoveTeamCollaboratorModal.propTypes = {
  environment: PropType.object.isRequired,
  collaborator: PropType.object.isRequired,
  onClose: PropType.func.isRequired
};

export default createFragmentContainer(
  withGqlClient(RemoveTeamCollaboratorModal),
  {
    collaborator: graphql`
      fragment removeTeamCollaboratorModal_collaborator on User
      @argumentDefinitions(
        teamFilter: { type: "TeamFilter", defaultValue: {} }
      ) {
        name
        id
        rowId
        teams(filter: $teamFilter) {
          nodes {
            id
            rowId
            name
            organization {
              rowId
            }
          }
        }
      }
    `
  }
);
